import React from 'react'

import {Select} from 'forms'

export const Enum = ({group, field, spec}) => (
   <div>
      <Select
         param={group + '.' + field}
         label={spec.label || group + '.' + field}
         options={spec.enum}
      />
   </div>
)

Enum.propTypes = {
   group: React.PropTypes.string.isRequired,
   field: React.PropTypes.string.isRequired,
   spec:  React.PropTypes.object.isRequired,
   value: React.PropTypes.any
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/fields/Enum.jsx